import {
  BlockOutlined,
  DeleteFilled,
  DeleteOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
  ImportOutlined,
  SyncOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "../Pages/CSS/Traitement.css";
import {
  Row,
  Col,
  Typography,
  Card,
  Select,
  Input,
  Radio,
  Button,
  Space,
  Form,
  Checkbox,
  Popconfirm,
  Table as AntTable,
  notification,
  InputNumber,
  Modal,
} from "antd";
import * as XLSX from "xlsx";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { CreateMdctsActesService } from "../Services/CreateMdctsActeService";
import { PrestationsService } from "../Services/PrestationsService";
import { SpecialitesService } from "../Services/SpecialitesService";
import confirm from "antd/lib/modal/confirm";
import { Tag } from "antd/lib";

const { Title } = Typography;
const { Option } = Select;
// Applique size="small" à tous les tableaux de cette page sans autre changement
const Table = ({ size = "small", ...props }) => <AntTable size={size} {...props} />;

const CreationActes = () => {
  const fileInputRef = useRef(null);
  const initialTableData = [];
  const [showEditForm, setShowEditForm] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [submittable, setSubmittable] = useState(false);
  const [prestations, setPrestations] = useState([]);
  const [specialites, setSpecialites] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedType, setSelectedType] = useState("00");
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("a");
  const [selectedPresta, setSelectedPresta] = useState("");
  const [tarifJour, setTarifJour] = useState(false);
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData);
  const [form] = Form.useForm();

  const createactesService = new CreateMdctsActesService();
  const prestationsService = new PrestationsService();
  const specialitesService = new SpecialitesService();

  useEffect(() => {
    setLoading(true);
    createactesService
      .getAllCreation()
      .then((data) => {
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        notification.error({
          message: "Erreur",
          description: "Erreur lors du chargement des actes.",
        });
      });
  }, []);

  useEffect(() => {
    setFilteredData(tableData);
  }, [tableData]);

  useEffect(() => {
    if (prestations.length === 0) {
      prestationsService
        .getAllPrestation()
        .then((data) => {
          setPrestations(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des prestations :", error);
        });
    }
  }, []);

  useEffect(() => {
    if (specialites.length === 0) {
      specialitesService
        .getAllSpecialites()
        .then((data) => {
          setSpecialites(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des prestations :", error);
        });
    }
  }, []);

  const onFinish = async (values) => {
    const updateObjet = {
      ...values,
      codeprest: selectedType || values.codeprest,
      coef: values.coef || 0,
      compte: prestations.find(
        (prestation) =>
          prestation.codeprest === (selectedType || values.codeprest)
      )?.compte,
      exclus: values.exclus || false,
      tarif_jour: values.tarif_jour || false,
      qte: values.qte || 1,
      taux_famille: values.taux_famille || 0,
      taux_part: values.taux_part || 0,
    };

    // console.log(updateObjet);
    try {
      // Vérifier d'abord si le codeacte existe déjà
      const existingActes = await createactesService.getAllCreation();
      const duplicate = existingActes.find(acte => acte.codeacte === values.codeacte);

      if (duplicate) {
        Modal.error({
          title: "Erreur de duplication",
          content: `Le code CIP "${values.codeacte}" existe déjà. Veuillez utiliser un code unique.`,
        });
        return; // Arrêter l'exécution si doublon
      }

      const response = await createactesService.addCreation(updateObjet);
      notification.success({
        message: "Succès",
        description: "Acte ajouté avec succès.",
      });
      const updatedTableData = await createactesService.getAllCreation();
      setTableData(updatedTableData);
      form.resetFields();
    } catch (error) {
      console.error("Erreur lors de l'ajout de l'acte :", error);

      // Vérifier si l'erreur est due à un doublon (au cas où la vérification précédente échoue)
      if (error.message && error.message.includes('duplicate') || error.message && error.message.includes('doublon')) {
        Modal.error({
          title: "Erreur de duplication",
          content: `Le code CIP "${values.codeacte}" existe déjà. Veuillez utiliser un code unique.`,
        });
      } else {
        notification.error({
          message: "Erreur",
          description: "Erreur lors de l'ajout de l'acte.",
        });
      }
    }
  };


  useEffect(() => {
    form.setFieldsValue({ codeprest: "00" });
  }, [form]);

  const handleDelete = async (numligne) => {
    try {
      const Deleteline = await createactesService.deleteCreation(numligne);
      const updatedTableData = await createactesService.getAllCreation();
      setTableData(updatedTableData);
      //  form.resetFields();
      notification.success({
        message: "Succès",
        description: "Acte supprimé avec succès.",
      });
    } catch (error) {
      console.error("Erreur lors de la suppression de la prestation :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la suppression de l'acte.",
      });
    }
  };

  const handleUpdate = async () => {
    try {
      if (selectedRowData) {
        const updatedFields = form.getFieldsValue();
        const { codeacte, codespe, codeprest, compte, numligne } =
          selectedRowData;

        const updatedData = {
          codeacte,
          codespe,
          codeprest,
          compte,
          ...updatedFields,
          numligne,
        };

        await createactesService.updateCreation(updatedData);
        const updatedTableData = await createactesService.getAllCreation();
        setTableData(updatedTableData);
        form.resetFields();
        notification.success({
          message: "Succès",
          description: "Acte mis à jour avec succès.",
        });
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la prestation :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la mise à jour de l'acte.",
      });
    }
  };

  const onchangeTarifJour = () => {
    setTarifJour(true);

  };
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleResetAll = async () => {
    try {
      const updatedData = await createactesService.getAllCreation();
      setTableData(updatedData);
      setSelectedRowKeys([]); // Réinitialiser seulement la sélection des lignes
      notification.success({
        message: "Succès",
        description: "Données actualisées avec succès.",
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de l'actualisation des données.",
      });
    }
  };

  useEffect(() => {
    let updatedData = [];
    if (selectedOption === "a") {
      updatedData = tableData;
    } else if (selectedOption === "b") {
      updatedData = tableData.filter((item) => item.exclus);
    } else if (selectedOption === "c") {
      updatedData = tableData.filter((item) => !item.exclus);
    }
    setFilteredData(updatedData);
  }, [selectedOption, tableData]);

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    setShowEditForm(true);
    setTarifJour(record.tarif_jour === true);
  };


  useEffect(() => {
    if (selectedRowData && form) {
      form.setFieldsValue({
        libacte: selectedRowData.libacte,
        tarif: selectedRowData.tarif,
        codeprest: selectedRowData.codeprest,
        exclus: selectedRowData.exclus,
        tarif_jour: selectedRowData.tarif_jour,
        nb_jour_max: selectedRowData.nb_jour_max,
        plafond_tarif_jour: selectedRowData.plafond_tarif_jour,
        plafond_part: selectedRowData.plafond_part,
        period_plafond: selectedRowData.period_plafond,
        lettre_cle: selectedRowData.lettre_cle,
        coef: selectedRowData.coef,
      });
    }
  }, [selectedRowData, form]);

  const handleNewButtonClick = () => {
    setShowEditForm(false);
    form.resetFields();
    setTarifJour(false); // reset du champ Nbr Jour Max
  };


  const handleExport = () => {
    // Utiliser les données de la table complète si aucune ligne n'est sélectionnée
    const exportData =
      selectedRowKeys.length > 0
        ? tableData.filter((item) => selectedRowKeys.includes(item.codeacte))
        : tableData.map((item) => ({
          Code: item.codeacte,
          Libellé: item.libacte,
          "Lettre Clé": item.lettre_cle,
          Coeff: item.coef,
          Tarif: item.tarif,
          Compte: item.compte,
          "Créer le": item.datecreation
            ? moment(item.datecreation).format("DD-MM-YYYY")
            : "",
          "Créer par": item.create_by,
        }));

    console.log("Export Data:", exportData); // Debug

    try {
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "CreationActes");
      XLSX.writeFile(workbook, "export_CreationActes.xlsx");
      notification.success({
        message: "Succès",
        description: "Les données ont été exportées avec succès.",
      });
    } catch (error) {
      console.error("Erreur lors de l'exportation:", error);
      notification.error({
        message: "Erreur",
        description: "L'exportation a échoué.",
      });
    }
  };

  const handlePrestaChange = (value) => {
    setSelectedType(value);
    form.setFieldsValue({ codeprest: value });
    const filtered = tableData.filter(
      (item) => (value ? item.codeprest === value : true) // Filtrer par `codeacte` égal au `codespe` sélectionné
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "codeacte",
      key: "codeacte",
      className: "small-cell",
      align: "center",
      ellipsis: true,
      sorter: (a, b) => {
        const valueA = a.codeacte || "";
        const valueB = b.codeacte || "";
        return valueA.localeCompare(valueB);
      },
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Libellé",
      dataIndex: "libacte",
      key: "libacte",
      className: "small-cell",
      ellipsis: true,
      sorter: (a, b) => {
        const valueA = a.libacte || "";
        const valueB = b.libacte || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Lettre Clé",
      dataIndex: "lettre_cle",
      key: "lettre_cle",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        const valueA = a.lettre_cle || "";
        const valueB = b.lettre_cle || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Coeff.",
      dataIndex: "coef",
      key: "coef",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        const valueA = a.coef || "";
        const valueB = b.coef || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      //exclusion -- return badge "Exclus" en rouge si exclus est true, sinon "Non exclus" en vert
      //utiliser plutot une icone rouge ou verte pour plus de lisibilité
      title: "Exclus",
      dataIndex: "exclus",
      key: "exclus",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (text, record) => (
        <Tag color={text ? "red" : "green"}>{text ? "Exclus" : "Non exclus"}</Tag>
      ),
    },
    {
      title: "Tarif",
      dataIndex: "tarif",
      key: "tarif",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        const valueA = a.tarif || "";
        const valueB = b.tarif || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        const valueA = a.compte || "";
        const valueB = b.compte || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Créer le",
      dataIndex: "datecreation",
      key: "datecreation",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (text) => (text ? moment(text).format("DD/MM/YYYY") : ""),
      sorter: (a, b) => {
        const valueA = new Date(a.datecreation).getTime();
        const valueB = new Date(b.datecreation).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "Créer par",
      dataIndex: "create_by",
      key: "create_by",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (text ? moment(text).format("DD/MM/YYYY") : ""),
      sorter: (a, b) => {
        const valueA = a.create_by || "";
        const valueB = b.create_by || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",
      ellipsis: true,
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.numligne)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const allRowKeys = filteredData.map((record) => record.numligne);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ],
  };

  const handleExclude = async (listeActe) => {
    Modal.confirm({
      title: "Confirmation d'exclusion",
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          Voulez-vous exclure les actes sélectionnés ? <br />
          {/* {listeActe.join(", ")} */}
        </div>
      ),
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          const response = await createactesService.updateExclusion(listeActe);
          if (response) {
            const updatedData = tableData.map((item) => {
              if (listeActe.includes(item.codeacte) && !item.exclus) {
                return { ...item, exclus: true };
              }
              return item;
            });
            setTableData(updatedData);
            setSelectedRowKeys([]);
            notification.success({
              message: "Succès",
              description: "Actes exclus avec succès.",
            });
            // Mettre à jour les données du tableau
            const data = await createactesService.getAllCreation();
            setTableData(data);
          } else {
            notification.error({
              message: "Erreur",
              description: "Erreur lors de l'exclusion des actes.",
            });
          }
        } catch (error) {
          console.error("Erreur lors de l'exclusion des actes :", error);
          notification.error({
            message: "Erreur",
            description: "Erreur lors de l'exclusion des actes.",
          });
        }
      },
      onCancel: () => {
        console.log("Annulation de la confirmation");
        setSelectedRowKeys([]); // Réinitialiser la sélection
      },
    });
  };

  const handleImportClick = () => {
    fileInputRef.current.value = ""; // Réinitialiser la valeur de l'input file
    fileInputRef.current.click();
  };

  // Fonction pour gérer la sélection du fichier
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        setFileData(jsonData); // Mettre à jour les données
        setIsModalVisible(true); // Ouvrir le modal pour afficher l'aperçu
      };
      reader.onerror = (error) => {
        console.error("Erreur lors de la lecture du fichier :", error);
        notification.error({
          message: "Erreur",
          description: "Une erreur est survenue lors de l'importation.",
        });
      };
      reader.readAsArrayBuffer(file);
    }
  };

  // Confirmation de l'importation des données
  const handleConfirmImport = async () => {
    try {
      await createactesService.importActes(fileData);
      notification.success({
        message: "Succès",
        description: "Données importées avec succès.",
      });
      setFileData([]); // Réinitialiser les données après l'importation
      setIsModalVisible(false); // Fermer le modal
    } catch (error) {
      console.error("Erreur lors de l'importation des actes :", error);
      notification.error({
        message: "Erreur",
        description: "L'importation a échoué.",
      });
    }
  };

  // Annulation de l'importation
  const handleCancelImport = () => {
    setIsModalVisible(false); // Fermer le modal
    setFileData([]); // Réinitialiser les données pour les imports futurs
  };

  // Génération dynamique des colonnes pour la table
  const columns1 = fileData[0]
    ? Object.keys(fileData[0]).map((key) => ({
      title: key,
      dataIndex: key,
      key: key,
      align: key === "libacte" ? "left" : "center", // Aligner à gauche pour "libacte", sinon centré
      render: (text) => <span>{text}</span>,
    }))
    : [];

  /*   if (selectedRowKeys.length > 0) {
      const updatedData = tableData.map((item) => {
        if (selectedRowKeys.includes(item.codeacte) && !item.exclus) {
          return { ...item, exclus: true };
        }
        return item;
      });


      setTableData(updatedData);
      setSelectedRowKeys([]);
      notification.success({
        message: "Succès",
        description: "Actes supprimés avec succès.",
      });
    } */
  /*   const Handlesuppresion = () => {
      
  }; */
  const Handlesuppresion = async () => {
    try {
      if (selectedRowKeys.length > 0) {
        const dataToDelete = tableData.filter((item) =>
          selectedRowKeys.includes(item.numligne)
        );

        // Supprimer les lignes sélectionnées en utilisant le service
        await createactesService.deleteCreationLines(dataToDelete);
        notification.success({
          message: "Succès",
          description: "Les actes sélectionnés ont été supprimés avec succès.",
        });
        // Recharger les données pour Rmettre à jour l'affichage
        const updatedTableData = await createactesService.getAllCreation();
        setTableData(updatedTableData);
        setSelectedRowKeys([]); // Réinitialiser la sélection
      } else {
        notification.warning({
          message: "Avertissement",
          description: "Veuillez sélectionner au moins un acte à supprimer.",
        });
      }
    } catch (error) {
      console.error("Erreur lors de la suppression des prestations :", error);
      notification.error({
        message: "Erreur",
        description:
          "Une erreur s'est produite lors de la suppression des actes.",
      });
    }
  };

  useEffect(() => {
    if (selectedType !== "") {
      const filteredByType = tableData.filter(
        (item) => item.codeprest === selectedType
      );
      setFilteredData(filteredByType);
    } else {
      setFilteredData(tableData);
    }
    const isValidTypeSelected = selectedType !== "";
    setSubmittable(isValidTypeSelected);
  }, [selectedType, tableData]);

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Card bordered>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} lg={12}>
                <Row gutter={8} align="middle">
                  <Col xs={12}>
                    <label>Type de prestation</label>
                    <Select
                      className="select-colored-accent"
                      style={{
                        width: "100%",
                        "--select-accent": "#1890ff",
                        "--select-accent-bg": "#e6f4ff",
                        "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                      }}
                      showSearch
                      value={selectedType}
                      onChange={handlePrestaChange}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      <Select.Option value={""}>Tous les types</Select.Option>
                      {prestations.map((prestation) => (
                        <Select.Option
                          key={`${prestation.codeprest} - ${prestation.intitule}`}
                          value={prestation.codeprest}
                        >
                          {`${prestation.codeprest} - ${prestation.intitule}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col xs={12}>
                    <br />
                    <Input
                      className="search-input-highlight"
                      placeholder="Rechercher..."
                      allowClear
                      prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                      style={{ width: "100%" }}
                      onChange={(e) => handleSearch(e.target.value)}
                      onPressEnter={(e) => handleSearch(e.target.value)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={12} lg={12}>
                <Row justify="end">
                  <Col span={24} style={{ textAlign: "right" }}>
                    <div style={{ display: "flex", gap: 8, marginBottom: "1rem" }}>
                      {[
                        { value: "a", label: "Tout" },
                        { value: "b", label: "Exclus" },
                        { value: "c", label: "Non exclus" },
                      ].map((item) => (
                        <button
                          key={item.value}
                          onClick={() => setSelectedOption(item.value)}
                          style={{
                            padding: "6px 14px",
                            borderRadius: 20,
                            border: "none",
                            cursor: "pointer",
                            fontSize: 13,
                            fontWeight: 500,
                            transition: "all 0.3s ease",
                            background: selectedOption === item.value
                              ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                              : "#f0f0f0",
                            color: selectedOption === item.value ? "#fff" : "#595959",
                            boxShadow: selectedOption === item.value
                              ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                              : "0 1px 3px rgba(0, 0, 0, 0.1)",
                          }}
                          onMouseEnter={(e) => {
                            if (selectedOption !== item.value) {
                              e.currentTarget.style.background = "#e0e0e0";
                              e.currentTarget.style.transform = "translateY(-1px)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (selectedOption !== item.value) {
                              e.currentTarget.style.background = "#f0f0f0";
                              e.currentTarget.style.transform = "translateY(0)";
                            }
                          }}
                        >
                          {item.label}
                        </button>
                      ))}
                    </div>
                  </Col>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Space
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        icon={<ImportOutlined />}
                        onClick={handleImportClick}
                        disabled={selectedType !== "06"}
                        className="buttonImport"
                      >
                        Importer
                      </Button>
                      {/* Input pour le fichier Excel */}
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                      />
                      <Button
                        className="buttonExport"
                        onClick={handleExport}
                        size="small"
                        icon={<ExportOutlined />}
                      >
                        Exporter
                      </Button>
                      {/*  <Button
                        disabled={selectedRowKeys.length === 0}
                        onClick={Handlesuppresion}
                        icon={<DeleteOutlined />}
                        size="small"
                        style={{ backgroundColor: "red", color: "white" }}
                      >
                        Supprimer
                      </Button> */}
                      <Popconfirm
                        title="Êtes-vous sûr de vouloir supprimer les actes sélectionnés ?"
                        onConfirm={Handlesuppresion}
                        okText="Oui"
                        cancelText="Non"
                      >
                        <Button
                          disabled={selectedRowKeys.length === 0}
                          icon={<DeleteOutlined />}
                          size="small"
                          style={{ backgroundColor: "red", color: "white" }}
                        >
                          Supprimer
                        </Button>
                      </Popconfirm>

                      <Button
                        disabled={selectedRowKeys.length === 0}
                        onClick={() => handleExclude(selectedRowKeys)}
                        icon={<BlockOutlined />}
                        size="small"
                        style={{ backgroundColor: "#9e7203", color: "white" }}
                      >
                        Exclure
                      </Button>
                      <Button
                        onClick={handleResetAll}
                        icon={<SyncOutlined />}
                        size="small"
                        //  style={{ backgroundColor: "#52c41a", color: "white" }}
                        className="buttonRefresh"
                      >
                        Actualiser
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          <Table
            rowSelection={rowSelection}
            rowKey={(record) => record.numligne}
            scroll={{ x: true }}
            className="custom-header1-table compact-rows-table"
            style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
            bordered
            columns={columns}
            showSorterTooltip={false}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}
            rowClassName={(record) =>
              selectedRowKeys.includes(record.numligne) ? "selected-row" : ""
            }
          />
        </Col>
        <Col xs={24} xl={6}>
          {!showEditForm && (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title
                    level={4}
                    style={{ margin: 0, marginLeft: "15px", color: "#ffffff" }}
                  >
                    Nouvel Acte
                  </Title>
                </div>
              }
            >
              <Form
                form={form}
                size="small"
                name="validateOnly"
                layout="vertical"
                autoComplete="off"
                onFinish={onFinish}
              >
                <Form.Item
                  name="codeprest"
                  label="Prestation"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner un type de prestation",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear={true}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder="Sélectionnez un type de prestation"
                    value={selectedType}
                    onChange={handlePrestaChange}
                  >
                    {/*  {prestations.map((prestation) => (
                      <Option
                        key={prestation.codeprest}
                        value={prestation.codeprest}
                      >
                        {prestation.codeprest} - {prestation.intitule}
                      </Option>
                    ))} */}
                    {prestations.map((prestation) => (
                      <Select.Option
                        key={`${prestation.codeprest} - ${prestation.intitule}`}
                        value={prestation.codeprest}
                      >
                        {`${prestation.codeprest} - ${prestation.intitule}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="libacte"
                  label="Libellé acte"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer le libellé de l'acte",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="tarif"
                  label="Tarif"
                  initialValue={0}
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer le tarif de l'acte",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Row gutter={8}>
                  <Col span={6}>
                    <Form.Item name="exclus" valuePropName="checked">
                      <Checkbox>Exclus</Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item name="tarif_jour" style={{ width: '100%' }} valuePropName="checked">
                      <Checkbox onChange={(e) => setTarifJour(e.target.checked)}>Acte Journalier</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                {tarifJour &&
                  <Row gutter={8}>
                    <Col span={10}>
                      <Form.Item name="nb_jour_max" label="Nbr Jour Max" initialValue={0}>
                        <InputNumber style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                    <Col span={14}>
                      <Form.Item name="plafond_tarif_jour" label="Plafond Tarif Jour" initialValue={0}>
                        <InputNumber style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>

                  </Row>

                }

                {selectedType == "06" && (
                  <Form.Item label="Code CIP" name="codeacte">
                    <Input />
                  </Form.Item>
                )}
                <Form.Item name="coef" label="Coeff." initialValue={0}>
                  <Input />
                </Form.Item>
                <Form.Item>
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                    //disabled={!submittable}
                    >
                      Enregistrer
                    </Button>
                    <Button htmlType="reset"
                      onClick={() => {
                        form.resetFields();
                        setTarifJour(false);
                      }}>Annuler</Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
          {showEditForm && selectedRowData && (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, color: "#ffffff" }}>
                    Modification Acte
                  </Title>
                </div>
              }
            >
              <Form
                form={form}
                size="small"
                name="validateOnly"
                layout="vertical"
                autoComplete="off"
              >
                <Form.Item
                  name="codeprest"
                  label="Prestation"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner un type de prestation",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear={true}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder="Sélectionnez un type de prestation"
                  >
                    {prestations.map((prestation) => (
                      <Option
                        key={prestation.codeprest}
                        value={prestation.codeprest}
                      >
                        {`${prestation.codeprest} - ${prestation.intitule}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="libacte"
                  label="Libellé acte"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer le libellé de l'acte",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="tarif"
                  label="Tarif"
                  initialValue={0}
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer le tarif de l'acte",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Row gutter={8}>
                  <Col span={6}>
                    <Form.Item name="exclus" valuePropName="checked">
                      <Checkbox>Exclus</Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item name="tarif_jour" style={{ width: '100%' }} valuePropName="checked">
                      <Checkbox onChange={(e) => setTarifJour(e.target.checked)}>Acte Journalier</Checkbox>
                    </Form.Item>
                  </Col>

                  {/*   <Col span={8}>
                    <Form.Item
                      name="plafond_part"
                      label="Plafond Acte"
                      style={{ width: "100%" }}
                    >
                      <InputNumber />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="period_plafond" label="Durée (en jrs)">
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </Col> */}
                </Row>
                {tarifJour &&
                  <Row gutter={8}>
                    <Col span={10}>
                      <Form.Item name="nb_jour_max" label="Nbr Jour Max" initialValue={0}>
                        <InputNumber style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                    <Col span={14}>
                      <Form.Item name="plafond_tarif_jour" label="Plafond Tarif Jour" initialValue={0} >
                        <InputNumber style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>

                  </Row>
                }

                <Form.Item name="lettre_cle" label="Lettre Clé">
                  <Input />
                </Form.Item>
                <Form.Item name="coef" label="Coeff." initialValue={0}>
                  <Input />
                </Form.Item>
                <Form.Item>
                  <Space>
                    <Button onClick={handleNewButtonClick}>Nouveau</Button>
                    <Button onClick={handleUpdate}>Modifier</Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>

      <Modal
        title="Importation Actes"
        visible={isModalVisible}
        onOk={handleConfirmImport}
        onCancel={handleCancelImport}
        okText="Importer"
        cancelText="Annuler"
        width="80%" // Largeur ajustée pour un meilleur aperçu
      >
        <Table
          dataSource={fileData}
          columns={columns1}
          scroll={{
            x: true,
          }}
          showSorterTooltip={false}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header1-table compact-rows-table"
          bordered
          rowKey={(record, index) => index}
          pagination={{ pageSize: 10 }}
        />
      </Modal>
    </div>
  );
};

export default CreationActes;
